import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { loadMongoData } from '@adornis/baseql/server/data-loader.js';
import type { BaseQLSelectionSet, NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import { InstitutionLegalDoc } from '../entities/institutionLegalDoc.js';

export const getLegalDocForInstitution = registerQuery({
  operationName: 'getLegalDocForInstitution',

  params: [
    { name: 'institutionID', type: () => String },
    { name: 'type', type: () => String },
    // Public pages want the global doc whenever the institution has none of its own; the admin
    // editor must not fall back, otherwise it would edit (and overwrite) the global doc.
    { name: 'fallbackToGlobal', type: () => Boolean },
  ],
  type: () => InstitutionLegalDoc,
  resolve:
    (
      institutionID: string | null,
      type: 'terms-of-use' | 'imprint' | 'privacy' | 'accessibility',
      fallbackToGlobal?: boolean,
    ) =>
    async (gqlFields: BaseQLSelectionSet<InstitutionLegalDoc>) => {
      const load = (id: string | null) =>
        loadMongoData(InstitutionLegalDoc, { institutionID: id, type } as any).then(docs => docs?.[0]);

      let data = await load(institutionID ?? null);

      if (fallbackToGlobal && institutionID && !data?.html) data = await load(null);

      return data as NarrowedEntity<InstitutionLegalDoc, typeof gqlFields>;
    },
});
